module.exports = __webpack_public_path__ + "nunito-sans-latin-800.a28845a6196298dad6dc0b2ba0b6de55.woff";